/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet} from 'react-router-dom'
import {useThemeMode} from '../../_metronic/partials/layout/theme-mode/ThemeModeProvider'
import {useMediaQuery} from 'react-responsive';

const PrivateLayout = () => {

  const {mode, updateMode} = useThemeMode()

  useEffect(() => {
    updateMode(mode)
  }, [mode])


  return (
    <div className="d-flex flex-column h-100">
      <div className="d-flex flex-row h-100 overflow-hidden">
        <Outlet />
      </div>
    </div>
  )
}

export {PrivateLayout}
